import React from "react";
import { Drawer } from "antd";

// A bottom sheet the width of the app column, like the ones in native apps.
const Sheet = ({ open, onClose, title, children, height = "auto", footer }) => (
  <Drawer
    className="app-sheet"
    placement="bottom"
    open={open}
    onClose={onClose}
    title={title}
    height={height}
    footer={footer}
    closable={false}
    destroyOnClose
  >
    <div className="app-sheet__grabber" aria-hidden="true" />
    {children}
  </Drawer>
);

export default Sheet;
